export const bookingFeeTypeList = (state) => state.bookingFeeTypeList;
